import { useContext } from 'react';
import { ActionsContext, GridUploadingContext } from './context';

export const useGridUploading = () => useContext(GridUploadingContext);
export const useModalActions = () => useContext(ActionsContext);
